import "./adquisicionVista.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import Titulo from "../../components/atoms/titles/Titulo";
import Button from "../../components/atoms/buttons/Button";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
// import IfError from "../../components/molecules/ifError/IfError";
import InstrucionesEspPDF from "../../resources/pdf/adquisicion/InstruccionesEspecialidadEmpleo.pdf";
import ClausulaPDF from "../../resources/pdf/adquisicion/17604_proteccion_de_datos.pdf";
import AcumuladoresTabAdquisicion from "../../components/molecules/tabs/acumuladoresTab/AcumuladoresTabAdquisicion";
import ButtonVolver from "../../components/atoms/buttons/ButtonVolver";

const AdquisicionVista = (object) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [solicitudesA1 ] = useState([]);
  const [solicitudesA2 ] = useState([]);

  const [disableBtnA1 ] = useState(false);
  const [disableBtnA2] = useState(false);

  const [dataAdquisicion] = useState(
    JSON.parse(localStorage.getItem("dataAdquisicion"))
  );
  // const [error] = useState(false);
  const [show, setShow] = useState({
    mensaje: false,
  });
  const [documentos] = useState([
    {
      titulo: "Instrucciones para la Especialidad de empleo",
      link: InstrucionesEspPDF,
    },
    {
      titulo: "Clausula de protección de datos",
      link: ClausulaPDF,
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const selectedIndexFunc = (index) => {
    
    setSelectedIndex(index);
  };
  useEffect(() => {
    if (dataAdquisicion.a1) {
      // getSolicitudesA1().then((data) => {
      //   
      //   setSolicitudesA1(data);
      //   setDisableBtnA1(
      //     data[0]?.estado === "BORRADOR" || data[1]?.estado === "BORRADOR"
      //   );
      // });
    }
    if (dataAdquisicion.a2) {
      // getSolicitudesA2().then((data) => {
      //   setSolicitudesA2(data);
      //   setDisableBtnA2(
      //     data[0]?.estado === "BORRADOR" || data[1]?.estado === "BORRADOR"
      //   );
      // });
    }
    localStorage.setItem("dataAdquisicion", JSON.stringify(dataAdquisicion));
    setLoading(true);
  }, [dataAdquisicion]);

  const handleClose = (e) => {
    setShow(false);
  };

  const marcado = (a1, a2) => {
    if (dataAdquisicion.a1 === false) {
      return a2;
    } else if (dataAdquisicion.a2 === false) {
      return a1;
    } else if (selectedIndex === -1) {
      if (dataAdquisicion.a1) {
        return a1;
      } else if (dataAdquisicion.a2) {
        return a2;
      } else {
        return a1;
      }
    } else if (selectedIndex === 0) {
      return a1;
    } else {
      return a2;
    }
  };

  return (
    <>
      <div className="vh-100" role="main" data-landmark-index="4">
        <Header></Header>
        {/* Documentos */}
        <div className="contanier d-flex flex-column align-items-center m-lg-5 m-md-5 m-sm-3 fondo p-2">
          {loading ? (
            <>
              <div className="container d-flex justify-content-start">
                <Titulo
                  tipo={"tituloModal "}
                  titulo={`Adquisición Especialidad Empleo (A1-A2)`}
                />
              </div>
              <p className="mt-2">
                Los siguientes documentos contienen información de interés
                acerca de la adquisición de especialidad:
              </p>
              <div className="container d-flex justify-content-between py-3 btnDocumentos">
                {documentos.map((documento, i) => (
                  <button
                    className="btn2 m-2 p-1"
                    type="button"
                    key={i}
                    onClick={() => window.open(documento.link)}
                  >
                    <i className="fa fa-file"></i> {documento.titulo}{" "}
                  </button>
                ))}
              </div>

              {/* solicitudes y reconocimientos */}
              {dataAdquisicion.a1 || dataAdquisicion.a2 ? (
                <>
                  <div className="row d-flex justify-content-center tablaRecNivel">
                    <div className="row col-12 card pb-5">
                      <AcumuladoresTabAdquisicion
                        solicitudesA1={solicitudesA1}
                        solicitudesA2={solicitudesA2}
                        selectedIndexFunc={selectedIndexFunc}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <SpinnerCircle></SpinnerCircle>
                </>
              )}
              <div className="d-flex align-items-center">
                <ButtonVolver
                  destino={"home"}
                  clases="col-3 mt-3"
                ></ButtonVolver>
                <Button
                  id="btnNuevaSolicitudNC"
                  clases={`btn-card seleccion-mes mt-3 ${
                    disableBtnA1 && marcado("A1", "A2") === "A1"
                      ? "btnDisable"
                      : disableBtnA2 && marcado("A1", "A2") === "A2"
                      ? "btnDisable"
                      : ""
                  }`}
                  nombre={
                    <>
                      <div
                        className={`${
                          disableBtnA1 && marcado("A1", "A2") === "A1"
                            ? "text-dark"
                            : disableBtnA2 && marcado("A1", "A2") === "A2"
                            ? "text-dark"
                            : ""
                        }`}
                      >
                        <i className={`fa-solid fa-file-circle-plus`}></i> Nueva
                        Solicitud {marcado("A1", "A2")}
                      </div>
                    </>
                  }
                  disabled={marcado(disableBtnA1, disableBtnA2)}
                  tipo="button"
                  funcion={() => {
                    if (marcado("A1", "A2") === "A1") {
                      navigate("/solicitudAdquisicionA1");
                    } else if( marcado("A1", "A2") === "A2") {
                      navigate("/solicitudAdquisicionA2");
                    }
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <SpinnerCircle></SpinnerCircle>
            </>
          )}
          <br />
        </div>
        <Footer></Footer>
      </div>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.content}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default memo(AdquisicionVista);
